// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MembershipBusinessListPagingResultModel from '../../model/membership-business-list-paging-result-model';
import MembershipBusinessListPagingResultDTO from '../dto/membership-business-list-paging-result-dto';
import dtoSchema from '../schemas/membership-business-list-paging-result-schema';
import MembershipBusinessListModel from '../../model/membership-business-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class MembershipBusinessListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MembershipBusinessListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => MembershipBusinessListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: MembershipBusinessListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<MembershipBusinessListPagingResultDTO>): MembershipBusinessListPagingResultModel;
  static toModel(dto: DeepPartial<MembershipBusinessListPagingResultDTO> | undefined | null): MembershipBusinessListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<MembershipBusinessListPagingResultDTO> | undefined | null): MembershipBusinessListPagingResultModel | undefined {
    return dto ? new MembershipBusinessListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MembershipBusinessListPagingResultModel> | MembershipBusinessListPagingResultModel): MembershipBusinessListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as MembershipBusinessListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MembershipBusinessListPagingResultModel, can not map to MembershipBusinessListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
